import React, {
  createContext,
  useContext,
  useReducer,
  useCallback,
} from "react";
import PropTypes from "prop-types";
import { useGetObjectives, useLoadObjectiveBranch } from "./hooks";
import { GOALS_ACTIONS } from "./actionTypes";
import { goalsReducer, initialState } from "./reducers";

const GoalsExploreContext = createContext();

export const useGoalsExploreContext = () => {
  const context = useContext(GoalsExploreContext);
  if (!context) {
    throw new Error(
      "useGoalsExploreContext must be used within GoalsExploreProvider"
    );
  }
  return context;
};

const GoalsExploreProvider = ({ children }) => {
  const [state, dispatch] = useReducer(goalsReducer, initialState);

  const handleDataLoaded = useCallback((data, { isRootLoad }) => {
    const objectives = data?.searchObjectives?.objectives || [];

    if (isRootLoad) {
      dispatch({
        type: GOALS_ACTIONS.LOAD_ROOT_OBJECTIVES,
        payload: { objectives },
      });
    } else {
      dispatch({
        type: GOALS_ACTIONS.LOAD_BRANCH_OBJECTIVES,
        payload: { objectives },
      });
    }
  }, []);

  const { loading: queryLoading, error: queryError } = useGetObjectives({
    onCompleted: handleDataLoaded,
  });

  const [loadBranch, { loading: branchLoading }] =
    useLoadObjectiveBranch(handleDataLoaded);

  const contextValue = {
    ...state,
    loading: state.loading || queryLoading || branchLoading,
    error: state.error || queryError,
    loadBranch,
    dispatch,
  };

  return (
    <GoalsExploreContext.Provider value={contextValue}>
      {children}
    </GoalsExploreContext.Provider>
  );
};

GoalsExploreProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GoalsExploreProvider;
